import { historyInstance } from '~/history';

export const setAuthenticated = () => {
  try {
    sessionStorage.setItem('authenticated', '1');
  } catch (err) {
    // TODO: gracefully handle over quota or permission error
    console.log(err);
  }
};

export const setUnauthenticated = () => {
  try {
    sessionStorage.setItem('authenticated', '0');
  } catch (err) {
    // TODO: gracefully handle over quota or permission error
    console.log(err);
  }
};

export const logout = () => {
  setUnauthenticated();
  historyInstance.push('/auth/request');
  window.location.reload();
};
